<main>
    <!-- Section -->
    <section class="vh-lg-100 bg-soft d-flex align-items-center">
        <div class="container">
            <div class="row justify-content-center form-bg-image" data-background-lg="../../assets/img/illustrations/signin.svg">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                        <div class="text-center text-md-center mb-4 mt-md-0">
                            <h1 class="mb-0 h3">Register to databroadcaster</h1>
                        </div>
                        <div class="mt-4">
                            <!-- Form -->
                            <div class="form-group mb-4">
                                <label for="email">Your Email</label>
                                <div class="input-group">
                                    <span class="input-group-text" id="basic-addon1"><span class="fas fa-envelope"></span></span>
                                    <input type="email" class="form-control" placeholder="example@company.com" bind:value={login} autofocus required>
                                </div>  
                            </div>
                            <!-- End of Form -->
                            
                            {#if success_msg}
                            <div class="alert alert-success" role="alert">
                                {success_msg}
                            </div>
                            {/if}
                            {#if error_msg}
                            <div class="alert alert-danger" role="alert">
                                {error_msg}
                            </div>
                            {/if}
                            <button class="btn btn-block btn-primary" on:click={sendLogin}>Register</button>
                            {#if success_msg}
                            <div class="d-flex justify-content-center align-items-center mt-4">
                                <span class="font-weight-normal">
                                    <a href="/" class="font-weight-bold">back to login</a>
                                </span>
                            </div>
                            {/if}
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>


<script>
import {push} from 'svelte-spa-router'

import {App, stApp} from '../dbclib/App.js'
import {User} from '../dbclib/User.js'

import { DBC_URL, stLang} from '../store.js'
import {axiosPost} from '../c0utils.js'

let success_msg = null
let error_msg = null

let login = ''

let user = new User()

function sendLogin() {
    success_msg, error_msg = null, null
    console.log("send login")
    axiosPost(DBC_URL + '/user/create', {
        USER: {
            login: login
        }
    })
    .then((result) => {
        console.log("then result", result)
        if(result.ok) success_msg = result.success_msg
        else error_msg = result.error_msg
    })
}

</script>